import { apiFetch } from '@/api/apiFetch';
import { t } from '@/translations/i18n';
import type { IProduct } from '@/typescript/interfaces/IProduct';

async function getProduct(productType: string): Promise<IProduct> {
    const response = await apiFetch(`/products/${productType}/`);
    if (!response.ok) {
        throw new Error(t('fetch_products_error'));
    }

    const product = (await response.json()) as IProduct;

    return product;
}

export { getProduct };
